import Vue from 'vue'
import { Notification } from 'element-ui'

export default async () => {
  try {
    await Vue.axios.get('/auth/otp_email')
  } catch (e) {
    Notification({message: 'Dịch vụ bị gián đoạn, vui lòng thử lại sau ít phút.', showClose: false, duration: 3000, customClass: 'warning'})
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/get-otp.js